<cx-storefront style="overflow-x: hidden; min-height: 0!important;">
</cx-storefront>

<!-- <ng-template [cxOutletRef]="testComponent" cxOutletPos="after" let-model>
    <p>Before component</p>
  </ng-template> -->
